import { IoStar } from 'react-icons/io5';

export const FavoriteIcon = () => <IoStar color="#fbc02d" />;
